<div class="layout-container">

  <!-- HEADER -->
  <app-header/>

  <!-- DYNAMIC CONTENT -->
  <main class="content">
    <router-outlet></router-outlet>
  </main>

  <!-- FOOTER -->
  <app-footer/>

  <!-- FLOATING ENQUIRY BUTTON -->
  <app-floating-enquiry/>

</div>
